import { render } from "./ApplicationLogo.vue?vue&type=template&id=364354ae"
const script = {}

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__